import axios from 'axios';

export const formulariosApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/formularios`
});